import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{attrs:{"to":"/"}},[_c(VImg,{attrs:{"width":_vm.logoSize.width,"height":_vm.logoSize.height,"src":"/assets/images/logo.svg","alt":"Кредитный брокер лого"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }